<lib-modal-container
  class="bootstrap-wrapper"
  classModalTitle="bg-azul-sunedu"
  [modalTitle]="'Documentos de trabajo'"
  cancelText="Cerrar"
  [noActions]="true"
  (dismiss)="handleClose()">

  <div class="m-b-25">
  </div>

</lib-modal-container>
